export const SUB_LOCATION_LIMIT = 300;
